<template>
    <div>
        <div class="d-flex align-items-center text-nowrap">
            <span :id="`ds-g-${k}`" class="material-icons-outlined mr-50 text-muted">info</span>
            {{ $safe(current,'GarageName') }}
        </div>
        <b-tooltip  :target='`ds-g-${k}`' triggers="hover">
            <template v-for="(g,i) in garages">
                <hr v-if="i != 0" :key="'d'+i" class="my-25 py-0"/>
                <div class="px-50 py-25 text-left"  :key="i">
                    <b>Garaj: </b>{{$safe(g,'GarageName') || '-'}}<br/>
                    <b>Başlangıç Tarihi: </b>{{$safe(g,'StartDateStr') || '-'}}<br/>
                    <b>Bitiş Tarihi: </b>{{$safe(g,'EndDateStr') || '-'}}
                </div>
            </template>
        </b-tooltip>
    </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'

export default {
    components:{
        BTooltip
    },
    props:{
        garages:Array,
        k:Number
    },
    computed:{
        current(){
            return (this.garages || [])[0] || null
        }   
    }
}
</script>